import { useEffect, useMemo } from 'react'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { formatOptionsList } from '../../../../features/formatters'

import {
  dv360ChannelsSelector,
  dv360ChannelsWasLoadedSelector,
  getDv360ChannelsIsLoadingSelector
} from '../../../../modules/selectors/dv360Constants'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { getDv360Channels } from '../../../../modules/actions/dv360Constants'

import { CHANNELS, CHANNELS_EXCLUDED } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from '../CategoriesSection/styles'

const ChannelsSection = ({ formik }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const dv360Channels = useSelector(dv360ChannelsSelector)
  const getDv360ChannelsIsLoading = useSelector(getDv360ChannelsIsLoadingSelector)
  const dv360ChannelsWasLoaded = useSelector(dv360ChannelsWasLoadedSelector)

  const formattedDv360Channels = useMemo(() => {
    return formatOptionsList({
      list: dv360Channels,
      valueName: 'id',
      labelName: 'name'
    })
  }, [dv360Channels])

  useEffect(() => {
    if (!dv360ChannelsWasLoaded) {
      dispatch(
        getDv360Channels({
          account: selectedAdAccountId
        })
      )
    }
  }, [dispatch, selectedAdAccountId, dv360ChannelsWasLoaded])

  return (
    <section className={classnames(drawerFormClasses.section, classes.categoriesSection)}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Channels')}</h3>
      <MultiSelectBox
        placeholder={t('Add a channel')}
        options={formattedDv360Channels}
        name={CHANNELS}
        value={values[CHANNELS]}
        isLoading={getDv360ChannelsIsLoading}
        setFieldValue={setFieldValue}
      />
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeCategoriesTitle)}>
        {t('Exclude channels')}
      </h3>
      <MultiSelectBox
        placeholder={t('Add a channel')}
        options={formattedDv360Channels}
        name={CHANNELS_EXCLUDED}
        value={values[CHANNELS_EXCLUDED]}
        isLoading={getDv360ChannelsIsLoading}
        setFieldValue={setFieldValue}
      />
    </section>
  )
}

export default ChannelsSection
